import { useState } from 'react';

export default function useToggle(initialValue: boolean) {
  const [state, setState] = useState(initialValue);
  const toggle = () => setState((state) => !state);

  return [state, toggle];
}
